import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Set initial countdown to 2 hours from now
    const endTime = new Date().getTime() + 2 * 60 * 60 * 1000;
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = endTime - now;
      if (distance < 0) {
        // Reset to 2 hours when countdown ends
        const newEndTime = new Date().getTime() + 2 * 60 * 60 * 1000;
        const newDistance = newEndTime - now;
        setTimeLeft({
          hours: Math.floor(newDistance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(newDistance % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(newDistance % (1000 * 60) / 1000)
        });
      } else {
        setTimeLeft({
          hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(distance % (1000 * 60) / 1000)
        });
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex items-center justify-center gap-4 bg-gradient-to-r from-orange-50 to-red-50 border border-orange-200 rounded-xl p-4" data-id="element-204">
      <div className="flex items-center gap-2 text-orange-700" data-id="element-205">
        <Clock className="w-5 h-5" data-id="element-206" />
        <span className="font-semibold text-sm" data-id="element-207">Oferta termina en:</span>
      </div>
      <div className="flex gap-2" data-id="element-208">
        <div className="bg-white rounded-lg px-3 py-2 min-w-[60px] text-center border border-orange-200" data-id="element-209">
          <div className="text-2xl font-bold text-slate-900" data-id="element-210">
            {String(timeLeft.hours).padStart(2, '0')}
          </div>
          <div className="text-xs text-slate-500 uppercase" data-id="element-211">Horas</div>
        </div>
        <div className="bg-white rounded-lg px-3 py-2 min-w-[60px] text-center border border-orange-200" data-id="element-212">
          <div className="text-2xl font-bold text-slate-900" data-id="element-213">
            {String(timeLeft.minutes).padStart(2, '0')}
          </div>
          <div className="text-xs text-slate-500 uppercase" data-id="element-214">Min</div>
        </div>
        <div className="bg-white rounded-lg px-3 py-2 min-w-[60px] text-center border border-orange-200" data-id="element-215">
          <div className="text-2xl font-bold text-slate-900" data-id="element-216">
            {String(timeLeft.seconds).padStart(2, '0')}
          </div>
          <div className="text-xs text-slate-500 uppercase" data-id="element-217">Seg</div>
        </div>
      </div>
    </div>;
}